const ATTR_MAP = {
    deepestPaywallStage: "ua_dps",
};

export default function pluckUserAttributeParams(userInfo = {}) {
    if (userInfo === null) {
        userInfo = {};
    }

    const {
        Metadata: {
            attribute = {},
        } = {},
    } = userInfo;

    return Object.keys(attribute).reduce((userAttributeParams, attributeName) => {
        const paramKey = ATTR_MAP[attributeName];

        if (paramKey) {
            userAttributeParams[paramKey] = attribute[attributeName];
        }

        return userAttributeParams;
    }, {});
}
